<template>
  <div class="ma-5">
    <div class="text-subtitle-1">Modificar Información</div>
    <div class="text-caption">A continuación, puedes consultar y modificiar tus datos de perfil de usuario.</div>
    <div class="text-overline mt-5">Información Básica</div>
    <v-row>
      <v-col>
        <div class="text-subtitle-1 text-medium-emphasis">Nombres</div>
        <v-text-field v-model="participant.nombres" density="compact" placeholder="Nombres" variant="outlined"
        :error-messages="v$.nombres.$errors.map(e => e.$message)"/>

        <div class="text-subtitle-1 text-medium-emphasis">Apellidos</div>
        <v-text-field v-model="participant.apellidos" density="compact" placeholder="Apellidos" variant="outlined"
        :error-messages="v$.apellidos.$errors.map(e => e.$message)"/>

        <div class="text-subtitle-1 text-medium-emphasis">Correo Electrónico Principal</div>
        <v-text-field v-model="participant.correo_principal" density="compact" placeholder="Correo Electrónico Principal" variant="outlined"
        :error-messages="v$.correo_principal.$errors.map(e => e.$message)"/>

        <div class="text-subtitle-1 text-medium-emphasis">Correo Electrónico Secundario</div>
        <v-text-field v-model="participant.correo_secundario" density="compact" placeholder="Correo Electrónico Secundario" variant="outlined"/>

        <div class="text-subtitle-1 text-medium-emphasis">Número de Contacto Principal</div>
        <v-text-field v-model="participant.contacto_principal" density="compact" placeholder="Número de Contacto Principal" variant="outlined"
        :error-messages="v$.contacto_principal.$errors.map(e => e.$message)"/>

        <div class="text-subtitle-1 text-medium-emphasis">Número de Contacto Secundario</div>
        <v-text-field v-model="participant.contacto_secundario" density="compact" placeholder="Número de Contacto Secundario" variant="outlined"/>                     
      </v-col>
      <v-col>
        <div class="text-subtitle-1 text-medium-emphasis">Selecciona tu país de residencia</div>
        <v-select v-model="participant.pais" density="compact" placeholder="Selecciona tu país de residencia" variant="outlined" 
        :items="country" item-title="label" item-value="value" 
        :error-messages="v$.pais.$errors.map(e => e.$message)"
        @update:modelValue="changeCountry()"/>

        <div class="text-subtitle-1 text-medium-emphasis">Selecciona tu departamento de residencia</div>
        <v-select v-model="participant.departamento" density="compact" placeholder="Selecciona tu departamento de residencia" variant="outlined" 
        :items="department" item-value="value" item-title="label" 
        :disabled="participant.pais !== 'Colombia'" 
        :error-messages="v$.departamento.$errors.map(e => e.$message)"
        @update:model-value="changeDepartment()"/>

        <div class="text-subtitle-1 text-medium-emphasis">Selecciona tu ciudad de residencia</div>
        <v-select v-model="participant.ciudad" density="compact" placeholder="Selecciona tu ciudad de residencia" variant="outlined" 
        :items="city" item-value="value" item-title="label" 
        :disabled="participant.pais !== 'Colombia'" 
        :error-messages="v$.ciudad.$errors.map(e => e.$message)"
        @update:model-value="changeCity()"/>

        <div class="text-subtitle-1 text-medium-emphasis">Selecciona el tipo de institución educativa</div>
        <v-select v-model="participant.tipo_institucion" density="compact" placeholder="Selecciona el tipo de institución educativa" variant="outlined" 
        :items="institutiontype" item-value="value" item-title="label" 
        :error-messages="v$.tipo_institucion.$errors.map(e => e.$message)"
        :disabled="participant.pais !== 'Colombia'"/>

        <div class="text-subtitle-1 text-medium-emphasis">Selecciona la institución educativa donde laboras</div>
        <v-autocomplete v-model="participant.id_institucion" density="compact" placeholder="Selecciona la institución educativa donde laboras" variant="outlined" 
        :items="institutionid" item-value="value" item-title="label" 
        :error-messages="v$.id_institucion.$errors.map(e => e.$message)"
        :disabled="participant.pais !== 'Colombia'"/>
      </v-col>
    </v-row>
    <div class="text-overline mt-5">Información Complementaria</div>
    <v-row>
      <v-col>
        <div class="text-subtitle-1 text-medium-emphasis">Selecciona ubicación de la institución educativa</div>
        <v-select v-model="participant.ubicacion_institucion" density="compact" placeholder="Selecciona ubicación de la institución educativa" variant="outlined" 
        :items="location" item-value="value" item-title="label"
        :error-messages="v$.ubicacion_institucion.$errors.map(e => e.$message)"/>

        <div class="text-subtitle-1 text-medium-emphasis">Selecciona una opción</div>
        <v-select v-model="participant.genero" density="compact" placeholder="Selecciona una opción" variant="outlined" 
        :items="gender" item-value="value" item-title="label"
        :error-messages="v$.genero.$errors.map(e => e.$message)"/>

        <div class="text-subtitle-1 text-medium-emphasis">Selecciona tu rango de edad</div>
        <v-select v-model="participant.edad" density="compact" placeholder="Selecciona tu rango de edad" variant="outlined" 
        :items="ages" item-value="value" item-title="label"
        :error-messages="v$.edad.$errors.map(e => e.$message)"/>
      </v-col>
      <v-col>
        <div class="text-subtitle-1 text-medium-emphasis">Selecciona tu nivel de formación</div>
        <v-select v-model="participant.formacion" density="compact" placeholder="Selecciona tu nivel de formación" variant="outlined" 
        :items="formation" item-value="value" item-title="label" 
        :error-messages="v$.formacion.$errors.map(e => e.$message)"/>

        <div class="text-subtitle-1 text-medium-emphasis">Selecciona tu rol</div>
        <v-select v-model="participant.cargo" density="compact" placeholder="Selecciona tu rol" variant="outlined" 
        :items="roles" item-value="value" item-title="label" 
        :error-messages="v$.cargo.$errors.map(e => e.$message)"
        @update:modelValue="changeRole()"/>

        <div class="text-subtitle-1 text-medium-emphasis">Selecciona tu trayectoria</div>
        <v-select v-model="participant.trayectoria" density="compact" placeholder="Selecciona tu trayectoria" variant="outlined" 
        :items="trajectory" item-value="value" item-title="label"
        :error-messages="v$.trayectoria.$errors.map(e => e.$message)"/>
      </v-col>
    </v-row>
    <div class="text-right">
      <v-btn variant="flat" color="warning" text="Actualizar Información Personal" @click="update()"/>
    </div>
    <v-dialog v-model="loading" max-width="320" persistent >
      <v-list class="py-2" color="primary" elevation="12" rounded="lg" >
        <v-list-item prepend-icon="mdi-clock" title="Espera..." >
          <template v-slot:prepend>
            <div class="pe-4">
              <v-icon color="primary" size="x-large"></v-icon>
            </div>
          </template>
          <template v-slot:append>
            <v-progress-circular color="primary" indeterminate="disable-shrink" size="16" width="2" />
          </template>
        </v-list-item>
      </v-list>
    </v-dialog>

    <v-dialog v-model="success.state" max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="success" icon="mdi-check-circle" size="112" />
        <h2 class="text-h5 mb-6">success</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ success.text }}
        </p>
        <v-divider class="mb-4"></v-divider>
        <div class="text-end">
          <v-btn class="text-none" color="success" variant="flat" text="Aceptar" @click="success.state = false"/>
      </div>
      </v-sheet>
    </v-dialog>

    <v-dialog v-model="error.state" max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-close-circle" size="112" />
        <h2 class="text-h5 mb-6">error</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ error.text }}
        </p>
        <v-divider class="mb-4"></v-divider>
        <div class="text-end">
          <v-btn class="text-none" color="error" variant="flat" text="Aceptar" @click="error.state = false"/>
      </div>
      </v-sheet>
    </v-dialog>
  </div>
</template>
<script setup>
  import Params from '@/models/params';
  import Participant from '@/models/participant';
  import axios from 'axios';
  import { ref, reactive, computed, onMounted } from 'vue';
  import { useVuelidate } from '@vuelidate/core'
  import { required, numeric, email, helpers } from '@vuelidate/validators'

  const participant = reactive(new Participant)
  
  const success = reactive({
    state: false,
    text: null
  })

  const error = reactive({
    state: null,
    text: null
  })

  const rules = computed(() => {
    return {
      nombres: { required: helpers.withMessage('Campo requerido.', required) },
      apellidos: { required: helpers.withMessage('Campo requerido.', required) },
      correo_principal: { 
        required: helpers.withMessage('Campo requerido.', required), 
        email: helpers.withMessage('Formato inválido', email)
      },
      contacto_principal: {
        required: helpers.withMessage('Campo requerido.', required), 
        numeric: helpers.withMessage('Campo requerido.', numeric), 
      },
      pais: { required: helpers.withMessage('Campo requerido.', required) },
      departamento: { required: helpers.withMessage('Campo requerido.', required) },
      ciudad: { required: helpers.withMessage('Campo requerido.', required) },
      tipo_institucion: { required: helpers.withMessage('Campo requerido.', required) },
      id_institucion: { required: helpers.withMessage('Campo requerido.', required) },
      ubicacion_institucion: { required: helpers.withMessage('Campo requerido.', required) },
      cargo: { required: helpers.withMessage('Campo requerido.', required) },
      trayectoria: { required: helpers.withMessage('Campo requerido.', required) },
      formacion: { required: helpers.withMessage('Campo requerido.', required) },
      edad: { required: helpers.withMessage('Campo requerido.', required) },
      genero: { required: helpers.withMessage('Campo requerido.', required) },
    }
  })

  const v$ = useVuelidate(rules, participant)

  const params = new Params

  const loading = ref(true)

  const formation = ref([])
  const ages = ref([])
  const roles = ref([])
  const department = ref([])
  const institutiontype = ref([])
  const location = ref(params.location)
  const gender = ref(params.gender)
  const country = ref(params.country)
  const trajectory = ref([])
  const city = ref([])
  const institutionid = ref([])

  async function getparticipant(){
    const frm = new FormData
    frm.append('action','data')
    frm.append('object','loaddata')
    frm.append('value',participant.documento)
    frm.append('token',localStorage.tokenaccess)
    const result = await eject(frm)
    loading.value = false
    if(result.status && result.data.length > 0){
      participant.setdata(result.data[0])
      department.value = await params.department()
      ages.value = await params.age()
      institutiontype.value = await params.institutiontype(participant.cargo, participant.edad)
      formation.value = await params.formation(participant.edad)
      roles.value = await params.roles(participant.edad)
      trajectory.value = await params.trajectory(participant.cargo, participant.edad)
      city.value = await params.city(participant.departamento)
      institutionid.value = await params.institutions(participant.ciudad)
    }else{
      error.text = 'Error al cargar los datos.';
      error.state = true;
    }
  }

  async function changeRole(){
    participant.trayectoria = null
    trajectory.value = await params.trajectory(participant.cargo, participant.edad)
  }

  async function changeCountry(){
    if(participant.pais !== 'Colombia'){
      participant.departamento = 100;
      participant.ciudad = 99998;
      participant.tipo_institucion = 8;
      participant.id_institucion = 1;
      city.value = await params.city(participant.departamento);
      institutionid.value = await params.institutions(participant.ciudad)
    }else{
      participant.departamento = null;
      participant.ciudad = null;
      participant.tipo_institucion = null;
      participant.id_institucion = null;
    }
  }

  async function changeDepartment(){
    participant.ciudad = null;
    participant.id_institucion = null;
    institutionid.value = [];
    city.value = await params.city(participant.departamento);
  }

  async function changeCity(){
    institutionid.value = await params.institutions(participant.ciudad);
  }

  async function update(){
    if(!await v$.value.$validate()){
      return
    }
    loading.value = true;
    let frm = new FormData;
    frm.append("action", "updatedata");
    frm.append("token", localStorage.tokenaccess);
    frm.append("data", JSON.stringify(participant));
    let result = await eject(frm);
    loading.value = false;
    if(result.status){
      success.text = result.message;
      success.state = true;
    }else{
      error.text = 'No se pudo procesar la solicitud.';
      error.state = true;
    }
  }

  function eject(f){
    return new Promise((resolve) => {
      axios.post(params.controller + 'beneficiario.php',f)
      .then(res => {
        resolve(res.data)
      })
      .catch(() => {
        resolve(null)
      })
    })
  }

  onMounted(()=>{
    participant.inscripcion = localStorage.inscription
    participant.documento = localStorage.document
    if(localStorage.tokenaccess){
      getparticipant()
    }    
  })
</script>